var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "summary-bar tw-flex tw-flex-wrap tw-items-center tw-justify-between"
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(_vm._s(_vm.statusMessage))]), _c('div', {
    staticClass: "tw-flex tw-gap-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "disabled": _vm.submitting
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    attrs: {
      "variant": "secondary",
      "disabled": !_vm.canSubmit || _vm.submitting
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('submit');
      }
    }
  }, [_vm.submitting ? _c('span', [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Transferring... ")], 1) : _c('span', [_vm._v("Review Transfer")])])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };